import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Card, CardBody, Row, Col, Label, Input } from 'reactstrap';
import Accumulation from './components/Accumulation';
import Adjustment from './components/Adjustment';
import CalculationHeader from './components/CalculationHeader';
import Pending from './components/Pending';
import Purchase from './components/Purchase';

const AccumulationDetails = ({tenantID,rowData,refetch, setHasToRest  }) => {
	const [ state, updateState ] = useState({
		activeType: 'Accumulation'
	});

	const [ rSelected, setRSelected ] = useState(1);
	const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));

	const onUpdateType = (type) => {
		setState({
			activeType: type
		});
	};

	const { activeType } = state;
	return (
		<Card>
			<CardBody>
				<Row>
					<Col xs="auto">
						<ButtonGroup className="radio-btn-group" >
							{/* <Button color="primary" disabled  onClick={() => setRSelected(1)}  active={rSelected === 1}>
								<Input name="radio2" type="radio"  checked={rSelected === 1} />340B
							</Button> */}
							{/* <Button color="primary" disabled outline  active={rSelected === 2} onClick={() => setRSelected(2)} >
								<Input name="radio2" type="radio" checked={rSelected === 2}  /> R<span className='text-lowercase'>etail</span>
							</Button> */}

							<p className="m-0 f-20 text-primary font-weight-600 primary">340B</p>
						</ButtonGroup>
					</Col>
					<Col className="ps-5">
						<Row>
							<Col md="3">
								<p className="m-0 f-14 ">NDC</p>
								<p className="m-0 f-14 font-weight-500">{rowData?.ndc}</p>
							</Col>
							<Col md="3">
								<p className="m-0 f-14 ">Drug Name</p>
								<p className="m-0 f-14 font-weight-500">{rowData?.drugName}</p>
							</Col>
							<Col md="3">
								<p className="m-0 f-14 ">Covered Entity</p>
								<p className="m-0 f-14 font-weight-500">{rowData?.coveredEntityName}</p>
							</Col>
							<Col md="3">
								<p className="m-0 f-14 ">Pharmacy</p>
								<p className="m-0 f-14 font-weight-500">{rowData?.pharmacyName}</p>
							</Col>
						</Row>
					</Col>
				</Row>
			</CardBody>
			<CardBody className="border-top">
				<CalculationHeader activeType={activeType} onUpdateType={onUpdateType} rowData={rowData} />
				{activeType === 'Accumulation' && <Accumulation tenantID={tenantID} rowData={rowData}/>}
				{activeType === 'Purchase' && <Purchase tenantID={tenantID} rowData={rowData}/>}
				{activeType === 'Pending' && <Pending tenantID={tenantID} rowData={rowData}/>}
				{activeType === 'Adjustment' && <Adjustment tenantID={tenantID} rowData={rowData} refetch={refetch}  setHasToRest = {setHasToRest} />}
			</CardBody>
		</Card>
	);
};

export default AccumulationDetails;
